import React from "react";
import { CalendarDays, PackageCheck, Receipt, Trophy, WalletCards } from "lucide-react";

const formatCurrency = (value) =>
    `₱${Number(value ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const MetricCards = ({ overview, periodLabel = "Selected Month", topProductsCount = 0 }) => {
    const cards = [
        { label: "Today", value: formatCurrency(overview.today), icon: CalendarDays },
        { label: periodLabel, value: formatCurrency(overview.month), icon: WalletCards },
        { label: "Orders", value: Number(overview.orders ?? 0).toLocaleString(), icon: Receipt },
        { label: "Avg Order", value: formatCurrency(overview.avg), icon: PackageCheck },
        { label: "Top Items", value: Number(topProductsCount ?? 0).toLocaleString(), icon: Trophy },
    ];

    return (
        <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
            {cards.map(({ label, value, icon: Icon }) => (
                <div key={label} className="rounded-[24px] border border-slate-200 bg-white p-4 shadow-[0_14px_35px_rgba(15,23,42,0.05)]">
                    <div className="flex items-center justify-between gap-3">
                        <div className="min-w-0">
                            <p className="truncate text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">{label}</p>
                            <p className="mt-2 truncate text-xl font-semibold tracking-tight text-slate-950">{value}</p>
                        </div>
                        <div
                            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl text-white shadow-sm"
                            style={{ background: "var(--color-primary)" }}
                        >
                            <Icon className="h-5 w-5" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MetricCards;
